import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { UntypedFormGroup } from '@angular/forms';
import { AppState, ExportActionTypes, OrdersActionTypes, SearchActionTypes, SortActionTypes } from '@app/core/ngrx';
import { MatDialog } from '@angular/material/dialog';
import { faRecycle, faLock } from '@fortawesome/free-solid-svg-icons';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'ecp-user-info-header',
  templateUrl: './user-info-header.component.html',
  styleUrls: ['./user-info-header.component.scss'],
  standalone: false,
})
export class UserInfoHeaderComponent {
  faRecycle = faRecycle;
  faLock = faLock;
  // @select('location')
  location$: Observable<any>;
  private loadedLocation;
  // @select('user')
  user$: Observable<any>;
  public loadedUser;
  @ViewChild('refreshBtn') refreshBtn: ElementRef;
  /**
   * form
   */
  public form: UntypedFormGroup;
  /**
   * currentTime
   */
  public currentTime: any;
  /**
   * username
   */
  public username: string;
  /**
   * constructor
   * @param {Store<AppState>} store
   * @param {MatDialog} dialog
   */
  constructor(private store: Store<AppState>, public dialog: MatDialog, private msalService: MsalService) {
    this.location$ = this.store.pipe(select((state) => state.location));
    this.user$ = this.store.pipe(select((state) => state.user));
    this.currentTime = new Date();
    this.location$.subscribe((location) => {
      this.loadedLocation = location.location;
    });
    this.user$.subscribe((user) => {
      this.loadedUser = user.profile;
    });
  }

  /**
   * refreshList
   */
  refreshList() {
    let payload;
    try {
      payload = this.loadedLocation.location
        ? this.loadedLocation.location
        : this.loadedUser.applicationProfiles[0].medLocation;
    } catch (e) {
      payload = this.loadedUser.applicationProfiles[0].medLocation;
    }
    this.store.dispatch({
      type: OrdersActionTypes.LOAD_ORDERS,
      payload: payload,
    });
    this.currentTime = new Date();
    this.store.dispatch({
      type: SortActionTypes.CLEAR_SORT_BY,
    });
    this.store.dispatch({
      type: SearchActionTypes.CLEAR_SEARCH_TERM,
    });
    this.store.dispatch({
      type: ExportActionTypes.CLEAR_EXPORT_BY,
    });

    this.refreshBtn.nativeElement.blur();
  }

  logout(): void {
    this.msalService.logout();
  }
}
